import { getTvObject, tv } from '@costar-ui/cosmos';
import fieldOptions from '../../../common/field-options/field-options.esm.js';

var textAreaTV = getTvObject({
  base: ['rounded-sm', 'border-neutral', 'p-2', 'text-p-16', 'leading-6', 'text-on-base', 'placeholder:text-neutral-strong', 'hover:border-hover', 'disabled:cursor-not-allowed', 'disabled:bg-action-disabled', 'w-full'],
  variants: {
    readOnly: {
      "true": 'bg-action-disabled hover:border-disabled focus:border-disabled'
    },
    resize: {
      vertical: 'resize-y',
      horizontal: 'resize-x',
      both: 'resize',
      none: 'resize-none'
    },
    isFocusWithin: fieldOptions.variants.isFocusWithin,
    isInvalid: fieldOptions.variants.isInvalid,
    isDisabled: fieldOptions.variants.isDisabled
  }
});
var base = tv(textAreaTV);
var textAreaStyles = {
  base: base
};

export { textAreaStyles, textAreaTV };
//# sourceMappingURL=text-area.styles.esm.js.map
